<template>
    <ModalFormCard class="modal-default" :action='"/admin/actions/subscription/" + subscription.company_id + "/add-free-cycle"'>
        <template #title>Add free month</template>

        <template #default="{ saving, errors }">
            <p class='text-15 font-semibold'>Add free month to {{ subscription.company.name }}</p>
            <p class='text-14 text-grey-900 mt-2'>
                You can use this to add a free month to a subscription.
                This will put them on a trial for the duration of this month.
            </p>

            <Select class='mt-4' name='reason'
                v-model:value='value.reason'
                placeholder='Reason'
                label='Reason for ad spend change' 
                :options="[
                    { value: 'Poor performance' },
                    { value: 'Other' },
                ]" 
            />

            <Textarea name='reason_other' v-model:value='value.reason_other' 
                label='Other reason' v-if='value.reason == "Other"' 
                class='mt-4'
            />

            <input type='hidden' name='contract_length' value='month' />

            <InputCheckbox class='mt-4' name="accepted" value="1">
                <p class="text-14 text-grey-900 pl-2">Are you sure you want to do this?</p>
            </InputCheckbox>

            <div class="modal-buttons pt-6">
                <ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
					Add free month
				</ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'

    export default {
        mixins: [Modal],

        data() {
            return {
                value: {
                    reason: null,
                    reason_other: '',
                }
            }
        },

        computed: {
            subscription() {
                return this.editingModel
            },
        }
    }
</script>